import { Mail, MapPin, Clock } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { InquiryForm } from "../components/InquiryForm";
import { CONTACT } from "../data/site";

const DETAILS = [
  { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}`, testid: "contact-email-link" },
  { icon: MapPin, label: "Bases of operations", value: `${CONTACT.baseUS} · ${CONTACT.baseCA}`, testid: "contact-location" },
  { icon: Clock, label: "Response time", value: "Within one business day", testid: "contact-response-time" },
];

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHeader
        overline="Contact"
        lines={["Tell us where", "you want to race."]}
        description="One inquiry starts the whole program — arrive-and-drive weekends, driver development, logistics, or full-season support. We reply within one business day."
      />

      <section data-testid="contact-section" className="border-t border-neutral-200 bg-white">
        <div className="mx-auto grid max-w-7xl gap-16 px-5 py-20 md:grid-cols-12 md:px-8 md:py-28">
          <div className="md:col-span-5">
            <Reveal>
              <p className="font-overline text-[10px] uppercase tracking-[0.35em] text-[#e63946] md:text-[11px]">
                Direct lines
              </p>
              <h2 className="font-display mt-5 text-3xl font-extrabold tracking-tight text-[#111111] sm:text-4xl">
                Straight to the
                <br />
                person who runs it.
              </h2>
              <p className="mt-5 max-w-md text-base leading-relaxed text-neutral-600">
                No call centers, no ticket queues. Your inquiry goes directly to
                the team that will run your program.
              </p>
            </Reveal>
            <div className="mt-10 space-y-0">
              {DETAILS.map((d, i) => (
                <Reveal key={d.label} delay={0.06 * i}>
                  <div className="flex items-center gap-5 border-t border-neutral-200 py-5">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-neutral-300 text-[#111111]">
                      <d.icon className="h-4.5 w-4.5 h-[18px] w-[18px]" />
                    </span>
                    <div>
                      <p className="font-overline text-[9px] uppercase tracking-[0.3em] text-neutral-500">{d.label}</p>
                      {d.href ? (
                        <a
                          data-testid={d.testid}
                          href={d.href}
                          className="mt-1 block text-base font-semibold text-[#111111] transition-colors duration-300 hover:text-[#e63946]"
                        >
                          {d.value}
                        </a>
                      ) : (
                        <p data-testid={d.testid} className="mt-1 text-base font-semibold text-[#111111]">
                          {d.value}
                        </p>
                      )}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="md:col-span-7">
            <Reveal delay={0.1}>
              <div className="border border-neutral-200 bg-[#f8f9fa] p-6 md:p-10">
                <InquiryForm />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
